import { render, staticRenderFns } from "./TodasComprasDiretas.vue?vue&type=template&id=27f57a31"
import script from "./TodasComprasDiretas.vue?vue&type=script&lang=js"
export * from "./TodasComprasDiretas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports